// Auto-generated from RequestNames

export const requestName = {
  create: 'create',
  createForProjectMember: 'create-for-project-member',
  date: 'date',
  delete: 'delete',
  details: 'details',
  detailsFromProjectMember: 'details-from-project-member',
  disable: 'disable',
  enroll: 'enroll',
  domainAUserGuid: 'domainAUserGuid',
  domainAUserNr: 'domainAUserNr',
  domainGuid: 'domainGuid',
  edit: 'edit',
  end: 'end',
  faviconPng: 'favicon-32x32',
  fileInfo: 'file-info',
  getAppData: 'getAppData',
  imageDelete: 'image-delete',
  imageSave: 'image-save',
  list: 'list',
  listAssignableFromDomainUser: 'list-assignable-from-domain-user',
  implicitSync: 'implicit-sync',
  listAssignableFromProjectMember: 'list-assignable-from-project-member',
  limits: 'limits',
  listDeleteDeep: 'list-delete-deep',
  listFromAccount: 'list-from-account',
  listFromActivity: 'list-from-activity',
  listFromClaimAction: 'list-from-claim-action',
  listFromClaim: 'list-from-claim',
  listFromContact: 'list-from-contact',
  listFromDomain: 'list-from-domain',
  listFromDomainUser: 'list-from-domain-user',
  listFromFunction: 'list-from-function',
  listFromProject: 'list-from-project',
  listFromProjectCategory: 'list-from-project-category',
  listFromProjectMember: 'list-from-project-member',
  listFromPage: 'list-from-page',
  listFromPageComponent: 'list-from-page-component',
  listFromRecord: 'list-from-record',
  listFromRole: 'list-from-role',
  listFromUser: 'list-from-user',
  listRestore: 'list-restore',
  login: 'login',
  access: 'access',
  mainPhoto: 'main',
  membersSync: 'members-sync',
  membersSyncFromDomainUser: 'members-sync-from-domain-user',
  membersSyncFromProjectMember: 'members-sync-from-project-member',
  ownerClaims: 'owner-claims',
  structureLocked: 'structure-locked',
  metadata: 'metadata',
  membershipPolicy: 'membership-policy',
  photoDescription: 'description',
  logo: 'logo',
  logoEmail: 'logo-email',
  logos: 'logos',
  projectAMemberGuid: 'projectAMemberGuid',
  projectAMemberNr: 'projectAMemberNr',
  projectGuid: 'projectGuid',
  reopen: 'reopen',
  close: 'close',
  peerVisibility: 'peer-visibility',
  mine: 'mine',
  messages: 'messages',
  send: 'send',
  messageEdit: 'message-edit',
  messageDelete: 'message-delete',
  markRead: 'mark-read',
  done: 'done',
  participantsAdd: 'participants-add',
  participantCandidates: 'participant-candidates',
  unreadCount: 'unread-count',
  pages: 'pages',
  partyCandidates: 'party-candidates',
  organisationOptions: 'organisation-options',
  sendFromProject: 'send-from-project',
  sendFromDomain: 'send-from-domain',
  candidatesFromProject: 'candidates-from-project',
  candidatesFromDomain: 'candidates-from-domain',
  sendFromTask: 'send-from-task',
  candidatesFromTask: 'candidates-from-task',
  acknowledge: 'acknowledge',
  recipients: 'recipients',
  refreshToken: 'refresh-token',
  register: 'register',
  role: 'role',
  revokeToken: 'revoke-token',
  sequence: 'sequence',
  share: 'share',
  signup: 'signup',
  start: 'start',
  summary: 'summary',
  status: 'status',
  observationTypeOptions: 'observation-type-options',
  taskTypeOptions: 'task-type-options',
  listFromTask: 'list-from-task',
  membersFromTask: 'members-from-task',
  reviewsFromTask: 'reviews-from-task',
  projectCategoryOptions: 'project-category-options',
  customerOptions: 'customer-options',
  customerSave: 'customer-save',
  twoFactorPolicy: 'two-factor-policy',
  confirm: 'confirm',
  resendConfirm: 'resend-confirm',
  forgotPassword: 'forgot-password',
  resetPassword: 'reset-password',
  changePassword: 'change-password',
  changeEmail: 'change-email',
  emailChange: 'email-change',
  passwordChange: 'password-change',
  settings: 'settings',
  confirmEmailChange: 'confirm-email-change',
  accept: 'accept',
  approve: 'approve',
  revoke: 'revoke',
  upload: 'upload',
  uploadAnnotated: 'upload-annotated',
  uploadEmail: 'upload-email',
  uploadLimits: 'upload-limits',
  restoreOriginal: 'restore-original',
  verifyTwoFactor: 'verify-two-factor',
  archive: 'archive',
  balanceRecalculate: 'balance-recalculate',
  billingDetails: 'billing-details',
  payment: 'payment',
  purchase: 'purchase',
  webhook: 'webhook',
  book: 'book',
  creditLimit: 'credit-limit',
  domainDiscount: 'domain-discount',
  dryRun: 'dry-run',
  invoice: 'invoice',
  domains: 'domains',
  proposalApprove: 'proposal-approve',
  proposalReject: 'proposal-reject',
  proposals: 'proposals',
  proposalsApprove: 'proposals-approve',
  proposalsCreate: 'proposals-create',
  storageRate: 'storage-rate',
  transactions: 'transactions',
} as const;

export type TRequestName = (typeof requestName)[keyof typeof requestName];
